<template>
  <div>
    <div
      v-if="bonuses.length > 0"
      class="font-bold"
    >
      Bonus{{ bonuses.length > 1 ? 'es' : '' }}
    </div>
    <div
      v-for="(eff, index) in bonuses"
      :key="'eff' + index"
      style="font-size: 90%;"
    >
      <span v-html="eff" />
    </div>
    <div
      v-if="productions.length > 0"
      class="font-bold mt-1"
    >
      Production{{ productions.length > 1 ? 's' : '' }}
    </div>
    <div
      v-for="(eff, index) in productions"
      :key="'eff' + index"
      style="font-size: 90%;"
    >
      <span v-html="eff" />
    </div>
  </div>
</template>

<script>
import {computed} from 'vue';
import {useLayoutStore} from '@/roc/stores/LayoutStore';

export default {
  props: {
    buildingId: {
      type: String,
      required: true
    }
  },
  setup (props) {
    const lytStore = useLayoutStore();

    const thisBuilding = computed(() => {
      return lytStore.buildings[props.buildingId];
    });

    return {
      bonuses: computed(() => {
        const r = [];
        for (let i = 0; i < thisBuilding.value.effects.count(); i++) {
          if (thisBuilding.value.effects.isBonus(i)) {
            const desc = thisBuilding.value.effects.getDescription(i, thisBuilding.value.era, thisBuilding.value.level);
            if (desc) {
              r.push(desc);
            }
          }
        }
        return r;
      }),
      productions: computed(() => {
        const r = [];
        for (let i = 0; i < thisBuilding.value.effects.count(); i++) {
          if (thisBuilding.value.effects.isProduction(i)) {
            const desc = thisBuilding.value.effects.getDescription(i, thisBuilding.value.era, thisBuilding.value.level);
            if (desc) {
              r.push(desc);
            }
          }
        }
        return r;
      })
    };
  }
};
</script>
